export default __webpack_public_path__ + "static/media/small-banner.260356c2.jpg";